var APP_LOAD_MENU_MAIN_SUCCESS = 'APP_LOAD_MENU_MAIN_SUCCESS';
var MENU_MAIN_SET_ACTIVE = 'MENU_MAIN_SET_ACTIVE';
var MENU_MAIN_LOAD_DYNAMIC_SUB_MENU_COMPLETE = 'MENU_MAIN_LOAD_DYNAMIC_SUB_MENU_COMPLETE';
var MENU_MAIN_LOAD_SUB_MENU_COMPLETE = 'MENU_MAIN_LOAD_SUB_MENU_COMPLETE';
var USER_SET_FLAG_URL = '/user/default/set-flag';
var APP_LOAD_MENU_MAIN_URL = '/common/menu/main';
var MENU_MAIN_LOAD_PROJECTS_URL = '/common/menu/load-projects';
var MENU_MAIN_LOAD_CHANNELS_URL = '/common/menu/load-channels';
var REDUCER_MENU_NAME = 'menu';
var LAYOUT_SMALL_COOKIE_KEY = 'layout_small';
export { APP_LOAD_MENU_MAIN_SUCCESS, MENU_MAIN_SET_ACTIVE, MENU_MAIN_LOAD_DYNAMIC_SUB_MENU_COMPLETE, MENU_MAIN_LOAD_SUB_MENU_COMPLETE, USER_SET_FLAG_URL, APP_LOAD_MENU_MAIN_URL, MENU_MAIN_LOAD_PROJECTS_URL, MENU_MAIN_LOAD_CHANNELS_URL, REDUCER_MENU_NAME, LAYOUT_SMALL_COOKIE_KEY };